import React from 'react'

import useTemplateId from '../../../hooks/useTemplateId'
import ConfiguratorActionButtons from 'components/ConfiguratorActionButtons'
import SlideInWrapper from 'components/SlideInWrapper'
import UnsavedChangesModal from 'components/UnsavedChangesModal'
import WhatsAppForm from 'components/forms/WhatsAppForm'
import { useFormState } from 'hooks/useFormState'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'
import { useToast } from 'hooks/useToast'
import { useUnsavedChangesModal } from 'hooks/useUnsavedChangesModal'

function Whatsapp() {
	const formId = 'whatsapp'
	const [state, handlers] = useFormState()
	const formRef = React.useRef<HTMLFormElement>(null)
	const { hideModal, handleDiscardChanges } = useUnsavedChangesModal(formRef, state.isDirty)
	const { templateId } = useTemplateId()
	const showToast = useToast()

	useSectionOpenedTracking()

	return (
		<>
			<UnsavedChangesModal onDiscardChanges={handleDiscardChanges} onStayHere={hideModal} name="WhatsApp" />
			<SlideInWrapper>
				<WhatsAppForm key={templateId} id={formId} {...handlers} onSubmitResult={showToast} />
				<ConfiguratorActionButtons formId={formId} {...state} />
			</SlideInWrapper>
		</>
	)
}

export default Whatsapp
